import { QuestionCircle } from '@geist-ui/icons';
import { Flex, Popover, Title, TitleOrder, UnstyledButton } from '@mantine/core'
import React from 'react'


type ComponentProps = {

    icon?: React.ReactNode;
    title?: string;
    titleOrder?: TitleOrder;
    popover?: string,
    children?: React.ReactNode;
}
function CardComponent({ icon, title, titleOrder, popover ,  children }: ComponentProps) {
    return (
        <div
            style={{
                
                width: "95%",
                height: "100%", /* Ensure the card takes full height */
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                gap: "16px", /* Assuming "md" is equivalent to 16px */
                backgroundColor: "white",
                padding: "16px", /* Assuming "sm" is 16px */
                flex: 1, /* Ensure the card stretches to available space */
                boxShadow : '0px 0px 20px rgba(0, 71, 136, 0.1)',
                borderRadius : '8px',

            }}
        >
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >       

                <Flex align={"center"} justify={"center"} gap={"sm"}>
                    <Title
                        order={titleOrder}
                        style={{
                            fontSize: "18px",
                            fontWeight: 700,
                            marginLeft: "12px",
                            color: "#264547",
                        }}
                    >
                        {title}
                    </Title>
                    { 
                        popover && (
                            <Popover zIndex={1} width={200} position="bottom" withArrow shadow="md">
                            <Popover.Target>
                              <UnstyledButton>
                                <QuestionCircle color='blue' />
                              </UnstyledButton>
                            </Popover.Target>
                            <Popover.Dropdown>
                               <p>{popover}</p>
                            </Popover.Dropdown>
                          </Popover>
                        )
                    }
                </Flex>

                {icon}
            </div>

            {/* <div
                style={{
                    display: "flex",
                    width: "100%",
                    padding: "24px",
                    justifyContent: 'space-between',
                    alignItems: "center",
                    height : '100%',
                }}
            >  */}
                {children}
            {/* </div> */}
        </div>
    )
}

export default CardComponent